import React, { useState, useEffect } from "react";
import axios from "axios";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Row, Col, Card } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';


ChartJS.register(ArcElement, Tooltip, Legend);

const Equity = () => {
  const BaseUrl = process.env.REACT_APP_API;
  const [equities, setEquities] = useState([]);
  const [totalInvested, setTotalInvested] = useState(0);
  const [totalCurrent, setTotalCurrent] = useState(0);

  useEffect(() => {
    axios.get(`${BaseUrl}/equities`)
      .then((response) => {
        setEquities(response.data.equities);
        setTotalInvested(response.data.totalInvested);
        setTotalCurrent(response.data.totalCurrent);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const calculatePercentage = (value, total) => {
    return ((value / total) * 100).toFixed(2);
  };

  const pieData = {
    labels: equities.map((item) => `${item.script} (${calculatePercentage(item.currentValue, totalCurrent)}%)`),
    datasets: [
      {
        data: equities.map((item) => item.currentValue),
        backgroundColor: ["#0088FE", "#FFBB28"],
        hoverBackgroundColor: ["#0050A0", "#FF8800"],
      },
    ],
  };

  useEffect(() => {
    if (equities.length > 0) {
        const table = $('#dataTable').DataTable({
            destroy: true, 
            pageLength: 10,
        });
        return () => {
            table.destroy();
        };
    }
}, [equities]);

const formatISTDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" });
};

  return (
    <>
            <Row>
        <Col xl={6} lg={6}>
          <Card className="widget-flat shadow-md" style={{ height: "200px" }}>
            <Card.Body className="p-0 d-flex flex-column justify-content-center align-items-center">
              <div className="p-3 pb-0 text-center">
                <div className="mb-2">
                  <i
                    className="mdi mdi-currency-usd text-danger widget-icon"
                    style={{ fontSize: "48px" }}
                  ></i>
                </div>
                <h5 className="text font-weight-normal mt-0">
                  Value Invested
                </h5>
                <h6 className="mt-2">{totalInvested.toLocaleString()}</h6>
              </div>
            </Card.Body>
          </Card>
          
          <Card className="widget-flat shadow-md" style={{ height: "200px" }}>
            <Card.Body className="p-0 d-flex flex-column justify-content-center align-items-center">
              <div className="p-3 pb-0 text-center">
                <div className="mb-2">
                  <i
                    className="mdi mdi-currency-usd text-success widget-icon"
                    style={{ fontSize: "48px" }}
                  ></i>
                </div>
                <h5 className="text font-weight-normal mt-0">
                  Current Value
                </h5>
                <h6 className="mt-2">
                {totalCurrent.toLocaleString()}{" "}
                {totalInvested > 0 && (
                  <span
                    className={`small ${
                      totalCurrent - totalInvested >= 0 ? "text-success" : "text-danger"
                    }`}
                  >
                    {`(${(
                      ((totalCurrent - totalInvested) / totalInvested) *
                      100
                    ).toFixed(2)}%)`}
                  </span>
                )}
              </h6>

              </div>
            </Card.Body>
          </Card>

        </Col>

        <Col xl={6} lg={6}>
        
                <div className="card p-3 w-100 d-flex flex-column align-items-center">
              <div className="card-header text-center">
                <h5>Overview of Equity</h5>
              </div>
              <div className="d-flex justify-content-center align-items-center" style={{ width: "100%", maxWidth: "350px", height: "350px" }}>
              <Pie data={pieData} />
              </div>
                </div>

        
        </Col>
      </Row>
      
        <div className="card basic-data-table">
            <div className="card-body">
                <table className="table bordered-table mb-0" id="dataTable" data-page-length={10}>
            <thead>
              <tr className="bg-gray-200">
               <th className="border p-2">Date</th>
                <th className="border p-2">Script</th>
                <th className="border p-2">Quantity</th>
                <th className="border p-2">Buy Price</th>
                <th className="border p-2">Invested Value</th>
                <th className="border p-2">Current Value</th>
                <th className="border p-2">% Change</th>
              </tr>
            </thead>
            <tbody>
              {equities.map((item, index) => {
                const percentageChange = ((item.currentValue - item.investedValue) / item.investedValue) * 100;
                return (
                  <tr key={index} className="text-center">
                    <td className="border p-2">{formatISTDate(item.date)}</td>
                    <td className="border p-2">{item.script}</td>
                    <td className="border p-2">{item.quantity.toLocaleString()}</td>
                    <td className="border p-2">{item.buy_price}</td>
                    <td className="border p-2">₹{item.investedValue.toLocaleString()}</td>
                    <td className="border p-2">₹{item.currentValue.toLocaleString()}</td>
                    <td className={`border p-2 ${percentageChange >= 0 ? "text-success" : "text-danger"}`}>{percentageChange.toFixed(2)}%</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
          </div>
          </>
  );
};

export default Equity;